export default __webpack_public_path__ + "static/media/logoNav.d08f853c.svg";